import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { FILTER_ENTITIES, NUMBER } from "../../../constants/app-constants";
import CarListingFaq from "../car-list-faq";

const SeoInterlinkingList = ({ isRevampClp, faqData = {}, browseSeoLinks = [] }) => {
    const accordionData = faqData || [];
    const handleEvent = (key) => {
        switch (key) {
        case FILTER_ENTITIES.MAKE: {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.VIEW_CARS_BY_MAKE);
            return;
        }
        case FILTER_ENTITIES.MODEL: {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.VIEW_CARS_BY_MODEL);
            return;
        }
        default: {
            return;
        }
        }
    };
    return (
        <React.Fragment>
            {isRevampClp && accordionData.length > NUMBER.ZERO ? <div styleName={"styles.outer"}>
                <div className={"container"}>
                    <h2 styleName={"styles.heading"}>Frequently Asked Questions</h2>
                    <CarListingFaq />
                </div>
            </div> : null}

            <div styleName={"styles.outer styles.SeoLinkContainer"}>
                <h3 styleName={"styles.SeoLinkHeading styles.mainHeading"}>Browse Used Cars In Australia</h3>
                {browseSeoLinks.map((item) => {
                    const {title = "" || "", seoLinks = [] || [], key = ""} = item || {};
                    return (
                        item && <div styleName={"styles.content"}>
                            <h3 styleName={"styles.SeoLinkHeading"}>{title} : </h3>
                            {seoLinks.map((linkItem, index) => {
                                const {text, seoLink} = linkItem;
                                return (<React.Fragment key={text}>
                                    <a styleName={"styles.seoLinkText"}
                                        href={seoLink}
                                        target="_blank"
                                        onClick={() => handleEvent(key)}>
                                        {text} {index === seoLinks.length - 1 ? null : <span styleName={"styles.separator"}>{"|"}</span> }
                                    </a>
                                </React.Fragment>);
                            }
                            )}
                        </div>);
                })}
            </div>
        </React.Fragment>
    );
};

SeoInterlinkingList.propTypes = {
    isRevampClp: PropTypes.bool,
    faqData: PropTypes.array,
    browseSeoLinks: PropTypes.array
};

export default SeoInterlinkingList;
